import React from 'react';
import { number, func, string, bool } from 'prop-types';
import styled from 'styled-components';

import ChevronLeft from './ChevronLeft';

const Text = styled.p`
  font-family: 'Nunito Sans', sans-serif;
  font-size: 16px;
  font-weight: normal;
  font-style: normal;
  line-height: 1.5;
  color: ${({ color }) => color};
`;

const Container = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  cursor: pointer;
  ${({ position }) => (position ? `position: ${position}` : '')}
  ${({ top }) => (top ? `top: ${top}px` : '')}
  ${({ left }) => (left ? `left: ${left}px` : '')}

  @media(min-width: 1000px) {
    ${({ onlyMobile }) => (onlyMobile ? 'display: none' : '')};
  }

  @media(max-width: 999px) {
    ${({ onlyDesktop }) => (onlyDesktop ? 'display: none' : '')};
  }
`;

const BackButton = ({
  text, color, position, top, left, onClick, onlyMobile, onlyDesktop,
}) => (
  <Container
    position={position}
    top={top}
    left={left}
    onClick={onClick}
    onlyMobile={onlyMobile}
    onlyDesktop={onlyDesktop}
  >
    <ChevronLeft fill={color} />
    <Text color={color}>{text}</Text>
  </Container>
);

BackButton.propTypes = {
  color: string,
  text: string.isRequired,
  position: string,
  top: number,
  left: number,
  onlyMobile: bool,
  onlyDesktop: bool,
  onClick: func,
};

BackButton.defaultProps = {
  color: '#4a4a4a',
  position: null,
  top: null,
  left: null,
  onlyMobile: false,
  onlyDesktop: false,
  onClick: () => { },
};

export default BackButton;
